// 避難所の現在人数を更新する。

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import axios from 'axios';
import PropTypes from 'prop-types';
/*-------------------
    classのimport
---------------------*/
import * as commons from './commons';
import Footer from './components/Footer';

import { EVA_PATH } from './constant/constant';

/*-------------------
    cssのimport
---------------------*/
import './css/post.css';

// クラス名
class HavenList extends Component {
  constructor(props) {
    super(props);

    document.title = `避難所 設定変更`;

    // URLを取得。
    const url = props.location.pathname;
    const pathSegments = url.split('/');

    // 末尾から取得
    const lgCrypt = pathSegments.at(-2);
    const mastaId = pathSegments.at(-1);

    this.state = {
      selectList: [],
      mastaId,
      lgCrypt,
    };
  }

  componentDidMount = async () => {
    const { mastaId, lgCrypt } = this.state;
    const { lgCd = '', permission = 0 } = await commons.getLgCd(lgCrypt);
    // FIXME:別途避難所投稿用の制限機能いりそう
    if (lgCd === '' || permission < 7) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const resData = await commons.getMarker({ lgCd, colName: 'M_HAVEN' });
    if (resData.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    this.getList(resData, mastaId);
  };

  /**
   * 避難所一覧を取得する。
   * @memberof HavenList
   */
  getList = async (dataList, mastaId) => {
    // リスト作成
    const tmpList = [];
    let setData = '';
    for (let i = 0; i < dataList.length; i += 1) {
      const { station, haven_id: havenId = '' } = dataList[i];
      const { name = '' } = station;
      if (havenId === parseInt(mastaId, 10)) setData = dataList[i];
      tmpList.push({ value: havenId, label: name });
    }

    const resSetData = this.changeValue(setData);

    this.setState({
      ...resSetData,
      selectList: tmpList,
    });
  };

  /**
   * 避難場所を変更した場合
   * @memberof HavenList
   */
  changeValue = (value) => {
    const { current = '', station = '' } = value;
    const { man = '', woman = '', household = '', support = '' } = current;
    const { name = '', capacity = '', address = '', open_flag: openFlag = '0' } = station;

    // 人数を計算する。
    const culcMan = man === '' ? 0 : man;
    const culcWoman = woman === '' ? 0 : woman;
    const culcSupport = support === '' ? 0 : support;
    const currentPeople = culcMan + culcWoman + culcSupport;
    const rate = capacity === '' ? '' : (currentPeople / capacity) * 100;

    const resCont = this.openContents(openFlag);
    const { color, text, icon } = resCont;

    this.setState({
      name,
      man,
      woman,
      support,
      household,
      rate,
      nowPeople: currentPeople,
      nowMan: man,
      nowWoman: woman,
      nowSupport: support,
      nowHousehold: household,
      capacity,
      address,
      sendOpenFlag: openFlag,
      openContent: (
        <>
          <span style={{ color, fontSize: '20px' }}>{icon}</span>&nbsp;
          {text}
        </>
      ),
    });
  };

  /**
   * 状態の要素を取得する。
   * @memberof HavenList
   */
  openContents = (openFlag) => {
    if (openFlag === '0') {
      return { color: '#7e7e7e', text: '閉設', icon: '●' };
    }
    if (openFlag === '1') {
      return { color: '#1f8d46', text: '開設', icon: '●' };
    }
    return { color: '#000000', text: '使用不可', icon: '×' };
  };

  /**
   * 信号種別用ラジオボタン
   *
   * @memberof HavenRegister
   */
  signalKindRadio = (objectKeyName, kind) => {
    const { [objectKeyName]: objState } = this.state;

    const resCont = this.openContents(kind);
    const { color, text, icon } = resCont;

    return (
      <label htmlFor={`${objectKeyName}_0${kind}`}>
        <input
          type="radio"
          id={`${objectKeyName}_0${kind}`}
          checked={objState === kind}
          onChange={() => this.setState({ [objectKeyName]: kind })}
        />
        &nbsp;<span style={{ color, fontSize: '20px' }}>{icon}</span>&nbsp;
        {text}
      </label>
    );
  };

  /**
   * 避難所設定変更時
   * @memberof HavenList
   */
  movePage = (id) => {
    const { history } = this.props;
    const { lgCrypt } = this.state;
    history.push({
      pathname: '/empty_page',
      path: `/public/haven/${lgCrypt}/${id}`,
    });
  };

  /**
   * 現在人数を送信する。
   * @memberof HavenList
   */
  send = async () => {
    const {
      mastaId = '',
      lgCd,
      capacity,
      man: tmpMan,
      woman: tmpWoman,
      support: tmpSupport,
      household: tmpHousehold,
      sendOpenFlag,
    } = this.state;

    const man = sendOpenFlag === '1' ? tmpMan : '';
    const woman = sendOpenFlag === '1' ? tmpWoman : '';
    const support = sendOpenFlag === '1' ? tmpSupport : '';
    const household = sendOpenFlag === '1' ? tmpHousehold : '';

    const resData = await axios
      .post(`${EVA_PATH}/p/v1/hv/u`, {
        mastaId,
        lgCd,
        man,
        woman,
        support,
        household,
        sendOpenFlag,
      })
      .then(() => true)
      .catch(() => false);

    if (resData === true) {
      // 人数を計算する。
      const culcMan = man === '' ? 0 : parseInt(man, 10);
      const culcWoman = woman === '' ? 0 : parseInt(woman, 10);
      const culcSupport = support === '' ? 0 : parseInt(support, 10);
      const currentPeople = culcMan + culcWoman + culcSupport;
      const rate = capacity === '' ? '' : (currentPeople / capacity) * 100;

      const resCont = this.openContents(sendOpenFlag);
      const { color, text, icon } = resCont;

      this.setState({
        rate,
        nowPeople: currentPeople,
        nowMan: man,
        nowWoman: woman,
        nowSupport: support,
        nowHousehold: household,
        capacity,
        openContent: (
          <>
            <span style={{ color, fontSize: '20px' }}>{icon}</span>&nbsp;
            {text}
          </>
        ),
      });

      window.alert('更新に成功しました。');
    } else {
      window.alert('更新に失敗しました。');
    }
  };

  /**
   * 単一のsetStateを行う。
   * @param {Object} objectKeyName -setStateするkey名
   * @param {Object} value -setStateする値
   */
  singleSet = (objectKeyName, value) => {
    this.setState({
      [objectKeyName]: value,
    });
  };

  /**
   * テスト用
   *
   * @memberof HavenList
   */
  test = async () => {};

  render() {
    const {
      mastaId,
      selectList,
      name = '',
      // 変更可能情報
      man,
      woman,
      support,
      household,
      sendOpenFlag,
      // 現在情報
      rate,
      capacity,
      address,
      openContent,
      nowPeople,
      nowMan,
      nowWoman,
      nowSupport,
      nowHousehold,
    } = this.state;

    if (name === '') return [];

    return (
      <div id="container">
        <div className="header-content">避難所一覧</div>
        <div className="Form" style={{ textAlign: 'center' }}>
          <p className="txtLarge">更新する避難所を変更する。</p>
          <select
            className="Form-Item-select mt10"
            onChange={(e) => {
              this.movePage(e.target.value);
            }}
            value={mastaId}
          >
            {selectList.map((d) => (
              <option key={d.label} value={d.value}>
                {d.label}
              </option>
            ))}
          </select>
          <h2 className="mt20">避難所の状態</h2>
          <table className="simpleTable" style={{ margin: 'auto' }}>
            <tbody>
              <tr>
                <td>名称</td>
                <td>{name}</td>
              </tr>
              <tr>
                <td>状態</td>
                <td>{openContent}</td>
              </tr>
              <tr>
                <td>住所</td>
                <td>{address}</td>
              </tr>
              {capacity === '' ? null : (
                <tr>
                  <td>最大収容人数</td>
                  <td>{`${capacity}人`}</td>
                </tr>
              )}
              <tr>
                <td>世帯数</td>
                <td>{nowHousehold === '' ? '-' : nowHousehold}</td>
              </tr>
              <tr>
                <td>現在人数</td>
                <td>{`${nowPeople}人${rate === '' ? '' : `(収容率：${rate.toFixed(2)}%)`}`}</td>
              </tr>
              <tr>
                <td rowSpan="3">内訳</td>
                <td>{`男性：${nowMan === '' ? '-' : `${nowMan}人`}`}</td>
              </tr>
              <tr>
                <td>{`女性：${nowWoman === '' ? '-' : `${nowWoman}人`}`}</td>
              </tr>
              <tr>
                <td>{`要支援者：${nowSupport === '' ? '-' : `${nowSupport}人`}`}</td>
              </tr>
            </tbody>
          </table>
          <h2 className="mt20">変更内容</h2>
          <p className="mt10 mb0">状態</p>
          <div>
            {this.signalKindRadio('sendOpenFlag', '1', '開設中')}
            &emsp;
            {this.signalKindRadio('sendOpenFlag', '0', '閉設中')}
            &emsp;
            {this.signalKindRadio('sendOpenFlag', 'n', '使用不可')}
          </div>
          {sendOpenFlag === '1' ? (
            <>
              <p className="mt20 mb0">現在人数</p>
              <table className="simpleTable" style={{ margin: 'auto' }}>
                <tbody>
                  <tr>
                    <td>世帯数</td>
                    <td>{commons.inputNumber('household', household, 0, '', this.singleSet)}</td>
                  </tr>
                  <tr>
                    <td>男性</td>
                    <td>
                      {commons.inputNumber('man', man, 0, '', this.singleSet)}
                      &nbsp;人
                    </td>
                  </tr>
                  <tr>
                    <td>女性</td>
                    <td>
                      {commons.inputNumber('woman', woman, 0, '', this.singleSet)}
                      &nbsp;人
                    </td>
                  </tr>
                  <tr>
                    <td>要支援者</td>
                    <td>
                      {commons.inputNumber('support', support, 0, '', this.singleSet)}
                      &nbsp;人
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : null}
          <div>
            <input
              type="submit"
              className="btn Form-Img point txtLarge mt30"
              value="送信"
              onClick={() => this.send()}
            />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

HavenList.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(HavenList);
